/**
 * How tall a playing quiz card is, at minimum.
 *
 * A quiz must not resize between its own questions — a two-word answer and a
 * two-line one have to land the taps in the same place — so every card that
 * plays a quiz holds this floor: the storefront player (`[tutor]/_ui/QuizCard`),
 * the builder's player (`components/builder/QuizPlayCard`), and the skeleton it
 * shows while the quiz is being written, so the real card resolves into exactly
 * the space its placeholder held. Neutral module rather than one of them
 * exporting to the other: the two players are different features and neither
 * owns the other's height.
 *
 * The card that ASKS the one question holds it too (2026-09-13): it is the
 * first frame of the same card, and it became the quiz without moving. It
 * stayed out while the ask was three steps, when the floor padded step one
 * with 87px of nothing.
 */
export const QUIZ_CARD_MIN_H = 'min-h-[360px]';
